import { useCallback, useState } from "react";

import { Column, ExternalLink, Icon, IconButton, Row, Text, TextButton, Tooltip, useAppPalette } from "@bridgesplit/ui";
import { Box, Drawer, drawerClasses } from "@mui/material";
import { MenuOutlined } from "@mui/icons-material";

import { FOOTER_LEFT_LINKS, FOOTER_SOCIAL_LINKS, NAV_ICON_BUTTON_SX } from "./constants";
import NavOptions from "./NavOptions";
import { useNavOptions } from "./util";

export default function MobileMenu() {
    const { paperBackground, border } = useAppPalette();

    const [open, setOpen] = useState(false);
    const close = useCallback(() => setOpen(false), []);
    const navOptions = useNavOptions({ isMobile: true });

    return (
        <>
            {!!navOptions.length && (
                <IconButton sx={NAV_ICON_BUTTON_SX} onClick={() => setOpen(true)} jsxIcon={<MenuOutlined />} />
            )}
            <Drawer
                anchor="left"
                open={!!open}
                sx={{
                    [`.${drawerClasses.paper}`]: {
                        background: paperBackground,
                        width: "70vw",
                        maxWidth: "300px",
                        display: "flex",
                        flexDirection: "column"
                    }
                }}
                onClose={close}
            >
                <Row spaceBetween sx={{ p: 2 }}>
                    <Row spacing={1}>
                        <Text>
                            <Icon type="logo-outer" />
                        </Text>
                    </Row>
                    <IconButton border={false} icon="reject" onClick={close} />
                </Row>
                <NavOptions options={navOptions} />

                {/* Mobile footer */}
                <Box sx={{ flexGrow: 1 }} />
                <Column sx={{ borderTop: border, p: 2 }} spacing={2}>
                    <Row sx={{ gap: 2, flexWrap: "wrap" }}>
                        {FOOTER_LEFT_LINKS.map(({ label, link }) => (
                            <ExternalLink key={label} target="_blank" rel="noopener" href={link}>
                                <TextButton color="caption">{label}</TextButton>
                            </ExternalLink>
                        ))}
                    </Row>
                    <Row spacing={2} sx={{ flexWrap: "wrap" }}>
                        {FOOTER_SOCIAL_LINKS.map(({ icon, label, link }) => (
                            <Tooltip key={label} title={label}>
                                <ExternalLink target="_blank" rel="noopener" href={link}>
                                    <IconButton
                                        textColor="caption"
                                        textVariant="body1"
                                        border={false}
                                        jsxIcon={icon}
                                        sx={{ p: 0.5 }}
                                    />
                                </ExternalLink>
                            </Tooltip>
                        ))}
                    </Row>
                </Column>
            </Drawer>
        </>
    );
}
